import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../../lib/supabase'
import type { RewardItem } from '../shared/rewardItems'

async function fetchBirthdayRewardItems(): Promise<RewardItem[]> {
  const { data, error } = await supabase
    .from('reward_items')
    .select('id, name, description, image_url, active')
    .eq('programme', 'birthday')
    .order('created_at', { ascending: true })

  if (error) throw error

  return data.map((r) => ({
    id: r.id,
    name: r.name as RewardItem['name'],
    description: r.description as RewardItem['description'],
    imageUrl: r.image_url,
    active: r.active,
  }))
}

export function useBirthdayRewardItems() {
  return useQuery({
    queryKey: ['birthday-reward-items'],
    queryFn: fetchBirthdayRewardItems,
  })
}
